module.exports = __webpack_public_path__ + "static/media/forrest-gump-sharing.49073fcd.jpg";